import React, { Component } from 'react';

// Components
import ChooseCategoryPanel from '../components/ChooseCategoryPanel';

class EntryPage extends Component {
  render() {
    return (
      <div>
        <ChooseCategoryPanel
          tagline="For better results, please choose a category that best relates to your profession"
          btnText="Choose a category"
        />
      </div>
    );
  }
}

export default EntryPage;
